import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { PageSpinner } from '@/components/ui/Feedback'
import { useAuthStore } from '@/store/auth'

/** Everything behind this is for a signed-in partner; the server checks the token on each request too. */
export function RequirePartner() {
  const status = useAuthStore((state) => state.status)
  const hydrate = useAuthStore((state) => state.hydrate)
  const location = useLocation()

  useEffect(() => {
    if (status === 'idle') void hydrate()
  }, [status, hydrate])

  if (status === 'idle' || status === 'authenticating') return <PageSpinner label="Checking your session" />
  if (status === 'anonymous') return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  return <Outlet />
}
